import React from 'react';

interface LegalDocumentFormatterProps {
  content: string;
}

const LegalDocumentFormatter: React.FC<LegalDocumentFormatterProps> = ({ content }) => {
  const parseContent = (text: string) => {
    const lines = text.split('\n');
    const elements: React.ReactNode[] = [];
    let key = 0;

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      if (!line) {
        elements.push(<div key={key++} className="h-2" />);
        continue;
      }

      // Headers with #
      if (line.startsWith('#')) {
        const headerText = line.replace(/^#+\s*/, '');
        elements.push(
          <p
            key={key++}
            dir="ltr"
            className={`font-bold text-[1.1rem] text-gold border-b-2 border-gold pb-1 mb-2 ${i > 0 ? 'mt-4' : ''} text-left`}
          >
            {headerText}
          </p>
        );
        continue;
      }

      // Section headers (all caps, < 50 chars)
      if (line.match(/^[A-ZÄÖÜ][A-ZÄÖÜ\s]+$/) && line.length < 50) {
        elements.push(
          <p key={key++} dir="ltr" className="font-semibold text-[1rem] text-foreground mb-2 mt-3 text-left">
            {line}
          </p>
        );
        continue;
      }

      // Numbered sections
      if (line.match(/^\d+\.\s+/)) {
        elements.push(
          <p key={key++} dir="ltr" className="font-semibold text-[0.95rem] text-foreground mb-1 mt-2 text-left">
            {line}
          </p>
        );
        continue;
      }

      // Bullet points
      if (line.match(/^\*\s+/) || line.match(/^-\s+/)) {
        const bulletText = line.replace(/^[\*\-\s]+/, '');
        elements.push(
          <div key={key++} className="flex items-start mb-1">
            <span className="text-foreground text-[0.9rem] mr-2 mt-px">•</span>
            <span className="text-foreground text-[0.9rem] leading-[1.5] flex-1 text-left">
              {bulletText}
            </span>
          </div>
        );
        continue;
      }

      // Indented sub-bullets
      if (line.match(/^\s{4,}[\*\-\s]+/)) {
        const bulletText = line.replace(/^\s{4,}[\*\-\s]+/, '');
        elements.push(
          <div key={key++} className="flex items-start mb-1 ml-6">
            <span className="text-foreground text-[0.85rem] mr-2 mt-px">◦</span>
            <span className="text-foreground text-[0.85rem] leading-[1.5] flex-1 text-left">
              {bulletText}
            </span>
          </div>
        );
        continue;
      }

      // Regular text
      elements.push(
        <p key={key++} dir="ltr" className="text-foreground text-[0.95rem] leading-[1.6] mb-1 text-left">
          {line}
        </p>
      );
    }

    return elements;
  };

  return <div className="w-full">{parseContent(content)}</div>;
};

export default LegalDocumentFormatter;
